var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappyFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.5 148.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c1b1a;\n      }\n\n      .cls-2 {\n        fill: #b09365;\n      }\n\n      .cls-3 {\n        fill: #1a1c16;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.25,
    cy: 74.25,
    r: 74.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.07,93.89c.29.16,2.85,3.82,4.21,4.95,15.18,12.56,37.04,15.1,53.86,3.99,2.91-1.92,7-7.02,8.89-7.99,7.18-3.66-1.5,7.42-2.92,8.82-17.18,16.93-54.04,15.09-65.98-6.74-1.25-2.28-1.16-4.73,1.94-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.16,52.01c8.5-2.48,10.44,17.36,1.97,18.22s-8.58-16.29-1.97-18.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.54,52.01c8.82-1.81,9.21,17.69,1.25,18.21-7.41.48-8.59-16.7-1.25-18.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFilled);
export default __webpack_public_path__ + "static/media/HappyFilled.85bfc33fcae16d858ed069a966268a96.svg";
export { ForwardRef as ReactComponent };